import React from 'react';
import { Typography, Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import MuiLink from '@material-ui/core/Link';
import { ReactComponent as BalanceSVG } from './assets/balance.svg';
import { useStyles } from './styles';

const CreditWidget = (props: any) => {
  const { userCredit } = props;
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();

  const onAccount = () => {
    history.push('/account');
  };

  return (
    <Box className={classes.widget}>
      <Typography
        component="span"
        variant="body1"
        className={classes.iconWrapper}
      >
        <BalanceSVG className={classes.icon} />
      </Typography>
      <Typography
        component="span"
        variant="body1"
        style={{
          fontWeight: 700,
          paddingRight: 8,
        }}
      >
        {t('v2.dashboard.widget_wallet_label_title')} {userCredit}
      </Typography>
      {location.pathname !== '/account' && (
        <Typography component="span" className={classes.separator}>
          |
        </Typography>
      )}
      {location.pathname !== '/account' && (
        <MuiLink onClick={onAccount}>
          <Typography
            component="span"
            variant="body1"
            className={classes.walletLink}
          >
            {t('v2.dashboard.appBar_top_cta_label_openWallet')}
          </Typography>
        </MuiLink>
      )}
    </Box>
  );
};

export default CreditWidget;
